{
    "NAME": "DisplayOptions",
    "DisplayOptions": "Display Options",
    "ExternalURL1": "Specify the external URL of the publicly available web site that this report's web content will be displayed from, e.g. https://www.google.com/maps/embed. Note that a suitable web address scheme (\"http://\" or \"https://\") should also be specified, and that \"https://\" is more likely to work in modern browsers, provided that the underlying web site actually supports it.",
    "ExternalURL2": "Warning: Displaying external content exposes the application to a reasonable security risk, where a 3rd party could maliciously gain access to the application's local web content & session information. Please click the Help button to learn more about these risks.",
    "LocalBrowserPerformance": "In order to significantly improve local browser performance when viewing larger (75 items+) BLF reports, you can specifically choose to turn off the large BLF tooltip and/or automatic text length adjustment feature(s).",
    "DisplayedAs": "Displayed As:",
    "ZoomLevel": "Zoom Level:",
    "PercentageUnit": "%",
    "LabelAuto": "Auto",
    "ChartStyle": "Chart Style:",
    "ChartProvider": "Chart Provider:",
    "ShowBLFTooltips": "Show Large BLF Tooltips",
    "AutomaticTextTruncationAdjustment": "Automatic Text Truncation Adjustment",
    "LabelURL": "URL:",
    "LabelShow": "Show:"
}